/* eslint-disable camelcase */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-children-prop */
import React, { useEffect, useState } from 'react';
import { Container, CssBaseline, Grid } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import useStyles from '../../assets/styles/pages/Promotions';
import Header from '../../components/Header';
import FooterMenuMain from '../../components/FooterMenuMain';

import { useLoadingContext } from '../../providers/use-loading';
import { ItypeReturnApi } from '../../helpers/utils/TypeReturnApi';
import { api } from '../../services';
import { useSignInContext } from '../../providers/use-signin';
import { FormatPrice } from '../../helpers/utils/Formating';
import { getStorege, saveStorege } from '../../helpers/db_storage';

const Promotion: React.FC = () => {
  const classeStyle = useStyles();
  const navigate = useNavigate();
  const signData = useSignInContext();
  const { createloading } = useLoadingContext();
  const { state, city, idRestaurante, idPromocao, dsRestaurante }: any =
    useParams();

  const [dataPromotion, setDataPromotion] = useState<any>();

  const handleToPage = (url: string) => {
    return navigate(url);
  };

  const handleListPromotion = async () => {
    const dataStorage = JSON.parse(
      localStorage.getItem('@mais/delivery/dataStateCity') as string,
    );
    createloading(true);

    if (!idRestaurante && !idPromocao) {
      try {
        const result: ItypeReturnApi =
          await api.apiMaisdelivery.shop.indexPromotions({
            nr_operacao: 19,
            idRestaurante: 0,
            dsCidade: dataStorage.dsCidade,
            idUsuario: signData.data?.user?.idUsuario,
          });
        setDataPromotion(result.data);
        createloading(false);
      } catch (error) {
        createloading(false);
        toast.error('Ocorreu um erro ao buscar as promoções.');
      }
    }
  };

  const handleListPromotionShop = async () => {
    const dataUserStorage = getStorege('@mais/delivery/user');

    createloading(true);
    if (idRestaurante && !idPromocao) {
      try {
        const getData: any = await api.apiMaisdelivery.shop.getShop({
          nr_operacao: 21,
          idRestaurante: window.atob(idRestaurante),
          idUsuario: dataUserStorage?.idUsuario
            ? dataUserStorage?.idUsuario
            : '0',
        });

        localStorage.setItem(
          '@mais/delivery/dataStateCity',
          JSON.stringify({
            dsCidade: getData?.data?.restaurante.dsCidade,
            idMarketplace: getData?.data?.restaurante.idMarketplace,
            idCidade: getData?.data?.restaurante.idCidade,
            idEstado: '',
          }),
        );

        const result: ItypeReturnApi =
          await api.apiMaisdelivery.shop.indexPromotions({
            nr_operacao: 19,
            idRestaurante: window.atob(idRestaurante),
            dsCidade: getData?.data?.restaurante.dsCidade,
            idUsuario: signData.data?.user?.idUsuario,
          });
        setDataPromotion(result.data);
        createloading(false);
      } catch (error) {
        createloading(false);
        toast.error('Ocorreu um erro ao buscar as promoções..');
      }
    }
  };

  const handleGetPromotionToPage = async (id_promotion: any, id_shop: any) => {
    createloading(true);
    try {
      const result: ItypeReturnApi =
        await api.apiMaisdelivery.shop.getMenuItensShop({
          nr_operacao: 33,
          idRestaurante: id_shop,
          idPromocao: id_promotion,
        });

      saveStorege(
        '@mais/delivery/shop/request/product/promotion',
        result.data[0],
      );
      createloading(false);
      handleToPage(
        `/shop/detail/list/product/subcategorie/${window.btoa(
          id_shop,
        )}/${window.btoa(id_promotion)}/${window.btoa('promotion')}`,
      );
    } catch (error) {
      createloading(false);
      toast.error('Ocorreu um erro ao buscar a promoção');
    }
  };

  useEffect(() => {
    if (state && city && idRestaurante && idPromocao && dsRestaurante) {
      handleGetPromotionToPage(idPromocao, idRestaurante);
    }
  }, [idRestaurante, idPromocao]);

  useEffect(() => {
    handleListPromotion();
  }, []);

  useEffect(() => {
    handleListPromotionShop();
  }, [idRestaurante]);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="Promotions" />
      <CssBaseline />
      <Grid marginBottom="100px">
        {dataPromotion &&
          dataPromotion.map((promotion: any) => (
            <Grid
              key={promotion.idPromocao}
              onClick={() =>
                handleGetPromotionToPage(
                  promotion.idPromocao,
                  promotion.idRestaurante,
                )
              }
            >
              <Grid
                className={classeStyle.gridBannerPromotion}
                container
                item
                justifyContent="center"
                alignItems="center"
                textAlign="center"
              >
                <Grid
                  container
                  item
                  justifyContent="center"
                  alignItems="center"
                  textAlign="center"
                >
                  <img
                    src={`${process.env.REACT_APP_API_IMG}${promotion.dsImagem}`}
                    alt="banner"
                    className={classeStyle.bannerPromotion}
                  />
                </Grid>
                <Grid
                  container
                  item
                  className={classeStyle.gridBannerPromotionDescription}
                >
                  <Grid
                    container
                    item
                    justifyContent="flex-start"
                    alignItems="center"
                    textAlign="center"
                    xs={3}
                    sm={2}
                  >
                    <img
                      src={`${process.env.REACT_APP_API_IMG}${promotion.dsImagemRest}`}
                      alt="banner"
                      className={classeStyle.bannerShop}
                    />
                  </Grid>
                  <Grid
                    container
                    item
                    textAlign="center"
                    justifyContent="center"
                    xs={6}
                    sm={8}
                  >
                    <Grid
                      container
                      item
                      xs={12}
                      textAlign="center"
                      justifyContent="center"
                    >
                      {promotion.flgAberto == 1 ? (
                        <p className={classeStyle.textTagLive}>Aberto</p>
                      ) : (
                        <p
                          style={{ backgroundColor: '#a51713' }}
                          className={classeStyle.textTagLive}
                        >
                          Fechado
                        </p>
                      )}
                    </Grid>

                    <h6 className={classeStyle.gridBannerPromotionTitle}>
                      {promotion.dsPromocao}
                    </h6>
                  </Grid>
                  {promotion.vlNormal != '0.00' ||
                  promotion.vlDesconto != '0.00' ? (
                    <Grid
                      item
                      xs={3}
                      sm={2}
                      className={classeStyle.gridBannerPromotionValue}
                    >
                      <p
                        className={classeStyle.gridBannerPromotionValueDefault}
                      >
                        De R${' '}
                        {promotion.vlNormal.length > 5
                          ? `${FormatPrice(promotion.vlNormal).substring(
                              0,
                              5,
                            )}...`
                          : FormatPrice(promotion.vlNormal)}
                      </p>
                      <p className={classeStyle.gridBannerPromotionValueText}>
                        Por apenas:
                      </p>
                      <Grid
                        className={
                          classeStyle.gridBannerPromotionValuePriceTotal
                        }
                      >
                        <p
                          className={
                            classeStyle.gridBannerPromotionValueDollarSign
                          }
                        >
                          R$
                        </p>
                        <p
                          className={classeStyle.gridBannerPromotionValuePrice}
                        >
                          {FormatPrice(promotion.vlDesconto)}
                        </p>
                      </Grid>
                    </Grid>
                  ) : (
                    ''
                  )}
                </Grid>
              </Grid>
            </Grid>
          ))}
      </Grid>
      <FooterMenuMain children="promotions" />
    </Container>
  );
};

export default Promotion;
